import * as SelectPrimitive from '@radix-ui/react-select';
import cx from 'classnames';

import Icon from '../../Icon';

import { ReactComponent as CheckSvg } from '@frontend/icons/check-line.svg';
import styles from './SelectOption.module.css';

const SelectOption = ({
  className,
  children,
  ...otherProps
}: React.ComponentPropsWithoutRef<
  typeof SelectPrimitive.Item
>): JSX.Element => {
  return (
    <SelectPrimitive.Item
      className={cx(styles['base'], className)}
      {...otherProps}
    >
      <SelectPrimitive.ItemText asChild>
        <div className={styles['content']}>{children}</div>
      </SelectPrimitive.ItemText>
      <SelectPrimitive.ItemIndicator className={styles['left-icon-wrapper']}>
        <Icon fillWithCurrentColor={false} size={16} component={<CheckSvg />} />
      </SelectPrimitive.ItemIndicator>
    </SelectPrimitive.Item>
  );
};

export default SelectOption;
